import {Breakpoints, CTA, Text} from '@volkswagen-onehub/components-core'
import {globalColorsNBD} from '@volkswagen-onehub/tokens'
import styled from 'styled-components'

export const FORM_BORDER_COLOR = globalColorsNBD.digitalCobalt['15']

export const CloseLayerCTA = styled(CTA)`
    display: block;
    margin: ${(props) => props.theme.size.static450} auto
        ${(props) => props.theme.size.static150};
`

export const LayerHeaderContainer = styled.div`
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    column-gap: ${(props) => props.theme.size.static200};
    box-sizing: border-box;
    width: 100%;
    padding-top: ${(props) => props.theme.size.static250};
    padding-right: ${(props) => props.theme.size.static100};
    padding-bottom: ${(props) => props.theme.size.static250};
    border-bottom: ${(props) => props.theme.size.border.light} solid
        ${FORM_BORDER_COLOR};
    background-color: ${(props) => props.theme.colors.background.primary};
`

export const LayerHeaderTitle = styled(Text)`
    min-width: 0;
    margin: 0;
    padding-left: ${(props) => props.theme.size.grid001};
    overflow-wrap: anywhere;

    @media (min-width: ${Breakpoints.b560}px) {
        padding-left: ${(props) => props.theme.size.static450};
    }

    @media (min-width: ${Breakpoints.b1600}px) {
        padding-left: ${(props) => props.theme.size.static550};
    }
`

export const LayerHeaderCloseCTA = styled(CTA)`
    grid-column: 2;
    justify-self: end;
    flex: 0 0 auto;
`

export const LayerForm = styled.form`
    &.no-logged {
        margin-top: ${(props) => props.theme.size.static500};
    }
`
